// @flow
/** @jsx h */

import { h } from 'preact'
import distanceInWordsStrict from 'date-fns/distance_in_words'
import differenceInSeconds from 'date-fns/difference_in_seconds'
import norwegianLocale from 'date-fns/locale/nb'
import { bem } from '../../../../../helpers/bem'
import styles from './LastUpdatedTime.css'

type Props = {
  lastUpdatedTime: Date
}

export function LastUpdatedTime (props: Props) {
  const diff = differenceInSeconds(Date.now(), props.lastUpdatedTime)
  const shouldShow = diff >= 60
  return (
    <div className={bem(styles.lastUpdatedTime, !shouldShow ? 'invisible' : '')} style>
      Sist oppdatert for{' '}
      {distanceInWordsStrict(new Date(), props.lastUpdatedTime, {
        includeSeconds: true,
        locale: norwegianLocale
      })}{' '}
      siden
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/components/LivePoll/LastUpdatedTime/LastUpdatedTime.js